import { SvgIcon, SvgIconProps } from '@mui/material';

export function IdMonitorIcon(props: SvgIconProps) {
  const { color } = props;
  return (
    <SvgIcon width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
      <g clip-path="url(#clip0_8732_1992)">
        <path
          d="M13.0223 11.7573L13.6552 13.6993L12 12.5017V8.61768L12.6329 10.5597H14.6775L13.0223 11.7573Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M22.1826 4.24004V13.6264C22.1826 18.3682 14.4909 21.3216 12.4057 22.0418V16.1025H12C14.5882 16.1025 16.6897 14.0067 16.6897 11.4255C16.6897 8.98178 14.8073 6.97504 12.4057 6.77275V1.91772L22.1826 4.24004Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M23.9996 2.84835V13.845C23.9996 19.7276 14.5067 23.1828 12.4053 23.8706V22.8915C14.1659 22.3251 22.9935 19.2098 22.9935 13.6265V3.60897L12.4053 1.09245V0.097168L23.9996 2.84835Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M1.00609 3.60897V13.6265C1.00609 19.2098 9.83367 22.3251 11.5943 22.8915V23.8706C9.4929 23.1828 0 19.7276 0 13.845V2.84835L11.5943 0.097168V1.09245L1.00609 3.60897Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M11.9998 8.61768V12.5017L10.3446 13.6993L10.9774 11.7573L9.32227 10.5597H11.3669L11.9998 8.61768Z"
          fill="black"
          fill-opacity="0.87"
        />
        <path
          d="M13.0223 11.7573L13.6552 13.6993L12 12.5017V8.61768L12.6329 10.5597H14.6775L13.0223 11.7573Z"
          fill="black"
          fill-opacity="0.87"
        />
        <path
          d="M22.1826 4.24004V13.6264C22.1826 18.3682 14.4909 21.3216 12.4057 22.0418V16.1025H12C14.5882 16.1025 16.6897 14.0067 16.6897 11.4255C16.6897 8.98178 14.8073 6.97504 12.4057 6.77275V1.91772L22.1826 4.24004Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M11.9999 16.1025H11.5943V22.0418C9.50907 21.3216 1.81738 18.3682 1.81738 13.6264V4.24004L11.5943 1.91772V6.77275C9.19264 6.97504 7.31028 8.98178 7.31028 11.4255C7.31028 14.0067 9.4117 16.1025 11.9999 16.1025Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M11.9998 8.61768V12.5017L10.3446 13.6993L10.9774 11.7573L9.32227 10.5597H11.3669L11.9998 8.61768Z"
          fill={color || '#4A3B8F'}
        />
        <path
          d="M13.0221 11.7573L13.6549 13.6993L11.9998 12.5017L10.3446 13.6993L10.9774 11.7573L9.32227 10.5597H11.3669L11.9998 8.61768L12.6326 10.5597H14.6772L13.0221 11.7573Z"
          fill={color || '#4A3B8F'}
        />
      </g>
    </SvgIcon>
  );
}
